module.exports = __webpack_public_path__ + "img/png5.eddf40cc.png";